export enum PickupAddressConstants {
  NOT_IMPLEMENTED = 'pickupAddress/NOT_IMPLEMENTED',
  SET_TYPE = 'pickupAddress/SET_TYPE',
  SET_TYPE_OPTIONS = 'pickupAddress/SET_TYPE_OPTIONS',
  SET_OTHER_TYPE = 'pickupAddress/SET_OTHER_TYPE',
  SET_HOSPITAL_UNIT = 'pickupAddress/SET_HOSPITAL_UNIT',
  SET_SCENE_GRID = 'pickupAddress/SET_SCENE_GRID',
  SET_MODE_DESCRIPTORS = 'pickupAddress/SET_MODE_DESCRIPTORS',
  SET_PICKUP_ADDRESS_MODE_DESCRIPTORS_PNNV = 'pickupAddress/SET_PICKUP_ADDRESS_MODE_DESCRIPTORS_PNNV',
  SET_LOCATION = 'pickupAddress/SET_LOCATION',
  SET_ADDRESS_LINE1 = 'pickupAddress/SET_ADDRESS_LINE1',
  SET_ADDRESS_LINE2 = 'pickupAddress/SET_ADDRESS_LINE2',
  SET_APT_SUITE_ROOM = 'pickupAddress/SET_APT_SUITE_ROOM',
  SET_MILE_POST_MAJOR_ROADWAY = 'pickupAddress/SET_MILE_POST_MAJOR_ROADWAY',
  SET_CROSS_STREET_DIRECTIONS = 'pickupAddress/SET_CROSS_STREET_DIRECTIONS',
  SET_CITY = 'pickupAddress/SET_CITY',
  SET_STATE = 'pickupAddress/SET_STATE',
  SET_ZIP = 'pickupAddress/SET_ZIP',
  SET_COUNTRY = 'pickupAddress/SET_COUNTRY',
  SET_CENSUS_TRACT = 'pickupAddress/SET_CENSUS_TRACT',
  SET_COUNTY = 'pickupAddress/SET_COUNTY',
  SET_MCD = 'pickupAddress/SET_MCD',
  SET_REFERRING_MD = 'pickupAddress/SET_REFERRING_MD',
  SET_REFERRING_MD_OTHER = 'pickupAddress/SET_REFERRING_MD_OTHER',
  SET_REFERRING_RN = 'pickupAddress/SET_REFERRING_RN',
  SET_REFERRING_USNG = 'pickupAddress/SET_REFERRING_USNG',
  SET_REFERRING_GPS_N = 'pickupAddress/SET_REFERRING_GPS_N',
  SET_REFERRING_GPS_E = 'pickupAddress/SET_REFERRING_GPS_E',
  SET_RFT = 'pickupAddress/SET_RFT',
  SET_RESPONSE_MODE = 'pickupAddress/SET_RESPONSE_MODE',
  SET_RESPONSE = 'pickupAddress/SET_RESPONSE',
  SAVE_PICKUP_ADDRESS = 'pickupAddress/SAVE_PICKUP_ADDRESS',
  SET_PICKUP_ADDRESS_STATE = 'pickupAddress/SET_PICKUP_ADDRESS_STATE',
  RESET_PICKUP_ADDRESS_STATE = 'pickupAddress/RESET_PICKUP_ADDRESS_STATE',
  CALCULATE_REFERRING_USNG = 'pickupAddress/CALCULATE_USNG',
  GET_COUNTY_OPTIONS = 'pickupAddress/GET_COUNTY_OPTIONS',
  SET_COMMON_ADDRESS = 'pickupAddress/SET_COMMON_ADDRESS',
  SET_STATE_IDS = 'pickupAddress/SET_STATE_IDS',
  SET_PICKUP_ADDRESS_DEFAULTS = 'pickupAddress/SET_PICKUP_ADDRESS_DEFAULTS',
  SET_PICKUP_ADDRESS_DEFAULTS_WITH_RESPONSE_MODE = 'pickupAddress/SET_PICKUP_ADDRESS_DEFAULTS_WITH_RESPONSE_MODE',
  SET_DEFAULT_HOSPITAL_CODE = 'pickupAddress/SET_DEFAULT_HOSPITAL_CODE',
  SET_DEFAULT_EMS_CODE = 'pickupAddress/SET_DEFAULT_EMS_CODE',
}
